import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { SettingsRoles } from '@/features/settings/roles'

export const Route = createFileRoute('/_authenticated/settings/roles')({
  beforeLoad: requireSuperAdmin,
  component: SettingsRoles,
})
